import { useState } from "react";
import { Row } from "@tanstack/react-table";
import { Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import type { AuditLogEntry } from "@/features-root-user/service/audit";
import { DataDiffViewer } from "./DataDiffViewer";

interface DataTableRowActionsProps {
  row: Row<AuditLogEntry>;
}

export function DataTableRowActions({
  row,
}: Readonly<DataTableRowActionsProps>) {
  const [isDiffDialogOpen, setIsDiffDialogOpen] = useState(false);
  const logEntry = row.original;

  return (
    <>
      {/* Direct View Changes button */}
      <Button
        variant="outline"
        size="sm"
        className="flex h-8 items-center px-3 py-1 text-xs"
        onClick={() => setIsDiffDialogOpen(true)}
      >
        <Eye className="mr-1 h-3.5 w-3.5" />
        View Changes
      </Button>

      <Dialog open={isDiffDialogOpen} onOpenChange={setIsDiffDialogOpen}>
        {/* Make dialog wider */}
        <DialogContent className="w-[90vw] sm:max-w-[1000px]">
          <DialogHeader>
            <DialogTitle>Audit Log Changes</DialogTitle>
            <DialogDescription>
              Organization:{" "}
              {logEntry.organizationName || logEntry.organizationId} (
              {logEntry.operationType})
              <br />
              Updated By: {logEntry.updatedByDisplayName} on{" "}
              {logEntry.updatedAt.toLocaleString()}
            </DialogDescription>
          </DialogHeader>
          <ScrollArea className="max-h-[70vh] pr-6">
            <DataDiffViewer
              oldData={logEntry.oldData}
              newData={logEntry.newData}
            />
          </ScrollArea>
        </DialogContent>
      </Dialog>
    </>
  );
}
